const {
  VITE_MSAL_CLIENT_ID,
  VITE_MSAL_TENANT_ID,
  VITE_MSAL_REDIRECT_URI,
  VITE_MSAL_SCOPE,
  VITE_APIM_URL,
  VITE_APIM_SUBSCRIPTION_KEY,
  VITE_APIM_VERSION,
  VITE_ADMIN_GROUP_ID,
  VITE_MAX_UPLOAD_FILES,
  VITE_MAX_FILE_SIZE_MB
} = import.meta.env

export const environment = {
  msalClientId: VITE_MSAL_CLIENT_ID || '',
  msalTenantId: VITE_MSAL_TENANT_ID || '',
  msalRedirectUri: VITE_MSAL_REDIRECT_URI || '',
  msalScope: VITE_MSAL_SCOPE || '',
  adminGroupId: VITE_ADMIN_GROUP_ID || '',
  // APIM configuration
  apimUrl: VITE_APIM_URL || 'https://api.dev.invivo-group.io/chatgpt-api',
  apimSubscriptionKey: VITE_APIM_SUBSCRIPTION_KEY || '370593d3c64c4d7f8eee6559ed462983',
  apimVersion: VITE_APIM_VERSION || '2025-04-03',
  maxUploadFiles: VITE_MAX_UPLOAD_FILES,
  maxFileSizeMB: VITE_MAX_FILE_SIZE_MB
}
